import React from 'react';
import './Features.css';

function Features() {
  const features = [
    {
      icon: '🧬',
      title: 'Trillion-Scale Vector Storage',
      description: 'Store embeddings directly on S3 at object-storage cost. No more re-sharding or running out of disk.',
    },
    {
      icon: '🐘',
      title: 'Native pgvector Queries',
      code: 'SELECT * FROM docs ORDER BY embedding <=> $1 LIMIT 10',
      description: 'Use standard SQL for similarity search. Works with your existing Postgres client and ORM.',
    },
    {
      icon: '🚀',
      title: 'Real-Time Ingestion',
      description: 'LSM engine absorbs millions of writes per second. Vectors are searchable within milliseconds of insertion.',
    },
    {
      icon: '🔀',
      title: 'Instant Branching',
      description: 'Fork terabyte-scale datasets in seconds. Perfect for A/B testing, experiments, and CI pipelines.',
    },
    {
      icon: '♾️',
      title: 'Bottomless Capacity',
      description: 'S3-backed storage grows without limit. No capacity planning, no re-sharding, no downtime migrations.',
    },
    {
      icon: '🔌',
      title: 'Full Postgres Compatibility',
      description: 'Works with every Postgres extension, ORM, and tool. Just change the storage layer, keep everything else.',
    },
  ];

  return (
    <section id="features" className="features">
      <div className="features__container">
        <p className="section-eyebrow">Features</p>
        <h2>Everything AI Workloads Need</h2>
        <p className="section-subtitle">
          Purpose-built storage for embeddings, vectors, and high-dimensional data inside Postgres.
        </p>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-card__icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              {feature.code && (
                <code className="feature-card__code">{feature.code}</code>
              )}
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Features;
